/* Copyright 2019-2021 Vmware, Inc. All rights reserved. -- Vmware Confidential */
/**
 * The open console service retrieves required params in order to open a console in a new browser tab
 */
angular.module('com.vmware.vsphere.client.vm')
      .factory('openConsoleService', ['dataService', 'clientLocale',
         function (dataService, clientLocale) {

            /** Public method **/
            return {
               openConsole: openConsole
            };

            function openConsole(vmUid, vmId, serverGuid) {
               dataService.getProperties(vmUid, ['name'])
                     .then(function(response) {
                  openConsoleUrl(vmId, response.name, serverGuid);
               });

               function openConsoleUrl(vmId, vmName, serverGuid) {
                  window.open("webconsole.html?"
                        + "vmId=" + vmId
                        + "&vmName=" + encodeURIComponent(vmName)
                        + "&serverGuid=" + serverGuid
                        + "&locale=" + clientLocale.get());
               }
            }

         }]);
